/**
 * Splits a full name into firstname and middlename components
 * Only processes if middlename is empty and firstname contains spaces
 * 
 * @param {string} firstname - The firstname field (may contain middle name)
 * @param {string} middlename - The middlename field
 * @returns {Object} - Object with displayFirstName and displayMiddleName
 * 
 * @example
 * splitNameFields("Tumelo Phetogo", "") 
 * // Returns: { displayFirstName: "Tumelo", displayMiddleName: "Phetogo" }
 * 
 * splitNameFields("Tumelo Phetogo Pheagane", "")
 * // Returns: { displayFirstName: "Tumelo", displayMiddleName: "Phetogo Pheagane" }
 * 
 * splitNameFields("Tumelo", "Phetogo")
 * // Returns: { displayFirstName: "Tumelo", displayMiddleName: "Phetogo" }
 */
export function splitNameFields(firstname, middlename) {
	const hasValue = (val) => val !== undefined && val !== null && val.toString().trim() !== "";

	let displayFirstName = firstname || "";
	let displayMiddleName = middlename || "";

	// Only split firstname if middlename is empty and firstname contains spaces
	if (!hasValue(displayMiddleName) && hasValue(displayFirstName) && displayFirstName.includes(" ")) {
		const nameParts = displayFirstName.trim().split(/\s+/);
		if (nameParts.length > 1) {
			displayFirstName = nameParts[0];
			displayMiddleName = nameParts.slice(1).join(" ");
		}
	}

	return { displayFirstName, displayMiddleName };
}
